import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useAPI } from '../hooks/useAPI';
import { contentAPI } from '../services/api';

const Blog = () => {
  const { data: content, loading, error } = useAPI(contentAPI.getBlogContent, []);

  if (loading) {
    return (
      <>
        <Header variant="light" />
        <div className="flex items-center justify-center min-h-screen">
          <div className="text-center">
            <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-teal-900 mx-auto mb-4"></div>
            <p className="text-xl text-gray-700">Loading blog posts...</p>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  if (error) {
    return (
      <>
        <Header variant="light" />
        <div className="flex items-center justify-center min-h-screen">
          <div className="text-center max-w-md">
            <h2 className="text-2xl font-bold text-red-600 mb-4">Error Loading Content</h2>
            <p className="text-gray-700">{error}</p>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  const blogPosts = content?.posts || [];

  return (
    <>
      <div>
        <section className="overflow-hidden">
          <Header variant="light" />
        </section>
      </div>

      <section className="py-12 lg:py-24">
        <div className="container mx-auto px-4">
          <div className="max-w-2xl mx-auto text-center mb-20">
            <h1 className="font-heading text-5xl sm:text-6xl tracking-xs mb-6">{content?.hero?.title || 'Blog'}</h1>
            <p className="text-lg text-gray-700">
              {content?.hero?.subtitle || 'Stay updated with the latest news, insights, and innovations in green energy.'}
            </p>
          </div>

          <div className="flex flex-wrap -mx-4 mb-16">
            {blogPosts.map((post) => (
              <div key={post.id} className="w-full md:w-1/2 lg:w-1/3 px-4 mb-8">
                <div className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300">
                  <img className="block w-full" src={post.image} alt={post.title} />
                  <div className="p-6">
                    <div className="flex items-center mb-4">
                      <span className="inline-block px-3 py-1 text-xs font-medium bg-lime-500 rounded-full">
                        {post.category}
                      </span>
                      <span className="ml-auto text-sm text-gray-600">{post.date}</span>
                    </div>
                    <h3 className="text-xl font-medium mb-3">{post.title}</h3>
                    <p className="text-gray-700 mb-4">{post.excerpt}</p>
                    <a className="inline-flex items-center text-black hover:text-lime-600 font-medium" href={post.link || "#!"}>
                      Read more
                      <svg className="ml-2" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.75 10H15.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                        <path d="M10 4.75L15.25 10L10 15.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Blog;
